import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";



function StripeWrapper(props) {
  const [stripeObject, setStripeObject] = useState(null);

  useEffect(() => {
    const fetchStripeObject = async () => {
      let params = new URL(document.location).searchParams;
      let userToken = params.get("tabclix");

      const stripekey = await fetch(
        `${process.env.REACT_APP_CMS_URL}/api/stripe-pubkey`,
        {
          method: "get",
          headers: {
            data: `${userToken}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      try {
        const userStripeKey = await stripekey.text();
        const res = await loadStripe(String(userStripeKey));
        setStripeObject(res);

      } catch (error) {
        return <>{props.children}</>;
      }

      if (!stripeObject) {
        return <>{props.children}</>;
      }
    };
    fetchStripeObject();
  }, []);

  return (
    <Elements stripe={stripeObject}>
      <>{props.children}</>
    </Elements>
  );
}

export default StripeWrapper;
